import React, { useState } from 'react';
import { Button, Text, Radio } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { events } from 'pages/settings/secondary/moving/state-machine';
import { scrollToBottom } from 'utils/scroll';
import { RadioGroup } from './radio-group.component';
import { MovingExplainedModal } from './moving-explained-modal.component';

const getCopy = copyFor('settings.moving.addUtilityServiceDetails');

interface Props {
  context: MovingStateMachineContext;
  matches: (state: string) => boolean;
  next: (...args: any[]) => any;
  send: (event: string) => void;
}

export const AddUtilityServiceDetails = ({
  next,
  context,
  send,
  matches,
}: Props) => {
  const { autoAddsOnlineAccount, displayName: utilityName } = context.utility;
  const [showMovingExplainedModal, setShowMovingExplainedModal] =
    useState(false);
  const isSetUp = matches('addUtilityServiceDetails.serviceSetUp');
  const showSecondRadioGroup = isSetUp && !autoAddsOnlineAccount;

  const serviceLegend = getCopy('serviceSet.legend');
  const serviceSetUp = getCopy('serviceSet.yes');
  const serviceNotSetUp = getCopy('serviceSet.no');

  const onlineLegend = getCopy('serviceOnline.legend', { utilityName });
  const onlineText = getCopy('serviceOnline.explanatoryText');
  const onlineLinkText = getCopy('serviceOnline.linkText');
  const serviceOnline = getCopy('serviceOnline.yes');
  const serviceNotOnline = getCopy('serviceOnline.no');

  return (
    <>
      <Text textStyle="heading800" tag="h1" margin={{ bottom: '40px' }}>
        {getCopy('title')}
      </Text>
      <RadioGroup legend={serviceLegend}>
        <Radio
          checked={isSetUp}
          margin={{ top: '16px' }}
          name={serviceLegend}
          onChange={() => {
            send(events.hasSetUpService);
          }}
          value={serviceSetUp}
        >
          {serviceSetUp}
        </Radio>
        <Radio
          checked={matches('addUtilityServiceDetails.serviceNotSetUp')}
          margin={{ bottom: '40px', top: '16px' }}
          name={serviceLegend}
          onChange={() => {
            send(events.hasNotSetUpService);
          }}
          value={serviceNotSetUp}
        >
          {serviceNotSetUp}
        </Radio>
      </RadioGroup>
      {showSecondRadioGroup && (
        <RadioGroup legend={onlineLegend}>
          <Text margin={{ bottom: '16px', top: '16px' }}>
            {onlineText}
            <Button
              backgroundless={true}
              onClick={() => {
                setShowMovingExplainedModal(true);
              }}
              size="small"
            >
              {onlineLinkText}
            </Button>
          </Text>
          <Radio
            checked={matches(
              'addUtilityServiceDetails.serviceSetUp.serviceOnline'
            )}
            margin={{ top: '16px' }}
            name={onlineLegend}
            onChange={() => {
              send(events.hasServiceOnline);
              scrollToBottom();
            }}
            value={serviceOnline}
          >
            {serviceOnline}
          </Radio>
          <Radio
            checked={matches(
              'addUtilityServiceDetails.serviceSetUp.serviceNotOnline'
            )}
            margin={{ bottom: '40px', top: '16px' }}
            name={onlineLegend}
            onChange={() => {
              send(events.doesNotHaveServiceOnline);
              scrollToBottom();
            }}
            value={serviceNotOnline}
          >
            {serviceNotOnline}
          </Radio>
        </RadioGroup>
      )}
      <Button
        fullWidth
        disabled={
          (matches('addUtilityServiceDetails.serviceSetUp.idle') &&
            !autoAddsOnlineAccount) ||
          matches('addUtilityServiceDetails.idle')
        }
        onClick={() => next()}
      >
        {getCopy('nextButton')}
      </Button>
      {showMovingExplainedModal && (
        <MovingExplainedModal
          onClose={() => setShowMovingExplainedModal(false)}
        />
      )}
    </>
  );
};
